import { Navigate, useLocation } from 'react-router-dom';
import { getCachedOnboardingCompleted } from '../../api/client';

/**
 * FTR-1115 / BUG-1132 — redirects new buyers (onboarding_completed=false) from / to /onboarding.
 * Sibling to DeepLinkHandler (App.tsx). Pure synchronous read off the module-level
 * cache populated by bootstrap().
 *
 * BUG-1132 fix: App-level bootstrap barrier (ensureBootstrapped) guarantees that
 * bootstrap() has settled BEFORE this component mounts. The cache is never null
 * at first render (eliminates the race where flag=null caused silent pass-through).
 * Returns null when flag is true (returning user) or path is not bare "/".
 *
 * BUG-1165: mount order does NOT prevent the race — both DeepLinkHandler's useEffect
 * and <Navigate>'s effect land in the same passive-effect flush, so /onboarding
 * overwrites the deep-link navigate. Protection: DeepLinkHandler stashes the target
 * in sessionStorage before navigating; PreparingStep consumes it after onboarding.
 */
export function FirstLaunchGate() {
  const location = useLocation();
  const flag = getCachedOnboardingCompleted();

  if (flag === false && location.pathname === '/') {
    return <Navigate to="/onboarding" replace />;
  }
  return null;
}
